// global computed children (this.children)
// global get specific child
// example: this.getChild(idChild)
export default {
  computed: {
    totalChildren () {
      return this.$store.getters.children.length || 0
    },
    selectedChild () {
      return this.$store.getters.selectedChild
    },
    children () {
      return this.getChildren()
    },
    globalChildByIdFilter () {
      return this.$store.getters.globalChildByIdFilter
    },
    globalChildByTextFilter () {
      return this.$store.getters.globalChildByTextFilter
    },
    orderChildrenBy () {
      return this.$store.getters.orderChildrenBy
    },
    orderChildrenSort () {
      return this.$store.getters.orderChildrenSort
    }
  },
  methods: {
    getChild (id, ignoreFilter) {
      ignoreFilter = ignoreFilter || false
      let children = this.children
      if (ignoreFilter === true) {
        children = this.getChildren(true)
      }
      if (children) {
        let child = children.find(function (child) {
          return child.id === parseInt(id)
        })
        if (child) {
          return child
        } else {
          if (!isNaN(id)) {
            // this.appendChildrenById([id])
          }
        }
      }
      return false
    },
    appendChildrenById (childIds) {
      childIds = childIds || []
      this.$request.get('/children?id_child=' + childIds.join(','))
      .then((response) => {
        if (!response.data) {
          return
        }
        if (response.data.length < 1) {
          return
        }

        for (let i = 0; i < response.data.length; i++) {
          this.$store.commit('ADD_OR_UPDATE_CHILD', response.data[i])
        }
      })
    },
    getItemsFilteredByChild(child, dataArray) {
      var filteredData = []
      for (var i = 0; i < dataArray.length; i++) {
        if (dataArray[i].child_id === child.id) {
          filteredData.push(dataArray[i])
        }
      }
      return filteredData
    },
    getChildIsPresent(child) {
      var present = this.getChildPresence(child)
      if (present === false) {
        return false
      }
      return true
    },
    getChildIsPresentDay(child) {
      var present = this.getChildPresenceDay(child)
      if (present === false) {
        return false
      }
      return true
    },
    setChildPresent(child, result) {
      // local
      var isset = false;
      var presence = JSON.parse(JSON.stringify(this.$store.getters.childrenPresence))
      if (presence.length > 0) {
        for (var i = 0; i < presence.length; i++) {
          if (typeof presence[i] !== 'undefined') {
            if (presence[i].child_id == child.id) {
              presence[i] = result
              isset = true
            }
          }
        }
      }
      if (isset === false) {
        presence.push(result)
      }
      this.$store.commit('SET_CHILDREN_PRESENCE', presence)
    },
    getChildPresence(child) {
      var presence = JSON.parse(JSON.stringify(this.$store.getters.childrenPresence))
      if (presence.length > 0) {
        for (var i = 0; i < presence.length; i++) {
          if (typeof presence[i] !== 'undefined') {
            if (presence[i].child_id == child.id && presence[i].end_time === '') {
              return presence[i]
            }
          }
        }
      }
      return false
    },
    getChildPresenceDay(child) {
      var presence = JSON.parse(JSON.stringify(this.$store.getters.childrenPresence))
      if (presence.length > 0) {
        for (var i = 0; i < presence.length; i++) {
          if (typeof presence[i] !== 'undefined') {
            if (presence[i].child_id == child.id) {
              return true;
            }
          }
        }
      }
      return false
    },
    getCurrentGroup(child) {
      var planning = this.$store.getters.planning
      var now = this.$moment()
      if (planning.length) {
        for (var i = 0; i < planning.length; i++) {
          if (planning[i].child.id == child.id) {
            var planItem = planning[i]
            var start = this.$moment(planItem.date + ' ' + planItem.start_time)
            var end = this.$moment(planItem.date + ' ' + planItem.end_time)
            // specifieke groep vandaag en NU (in het geval dat kindje verschillende groepen heeft op 1 dag)
            if (now >= start && now <= end) {
              return planItem.group.id
            }
          }
        }
        // voor het geval dat planning niet NU is (tijden) maar wel vandaag, kies er dan gewoon een
        for (var j = 0; j < planning.length; j++) {
          if (planning[j].child.id == child.id) {
            var planItem2 = planning[j]
            return planItem2.group.id
          }
        }
      }
      alert('Kon de groep niet bepalen, probeer opnieuw');
      return null
    },
    getChildren (getAll) {
      getAll = getAll || false
      var children = this.sortChildren(this.$store.getters.children)
      if (getAll === true) {
        return children
      }
      return this.sortChildren(this.getPartialChildren(children))
    },
    getPartialChildren (children) {
      var filterByIds = this.globalChildByIdFilter
      var filterByText = this.globalChildByTextFilter

      if (filterByIds.length < 1 && filterByText === '') {
        return children
      }

      var partialChildren = children

      if (filterByIds.length > 0) {
        partialChildren = partialChildren.filter(function (obj) {
          return filterByIds.indexOf(obj.id) > -1 || filterByIds.indexOf(obj.id_child) > -1
        })
      }

      if (filterByText !== '') {
        var query = filterByText.toLowerCase()
        var self = this
        partialChildren = this.$lodash().filter(partialChildren, function (child) {
          if (
              typeof child.first_name === 'undefined'
              ||
              typeof child.last_name === 'undefined'
              ||
              typeof child.full_name === 'undefined'
          ) {
            return true
          }
          return (
              self.$lodash().includes(child.first_name.toLowerCase(), query)
              ||
              self.$lodash().includes(child.last_name.toLowerCase(), query)
              ||
              self.$lodash().includes(child.full_name.toLowerCase(), query)
              ||
              (
                child.school !== null
                &&
                child.school.name
                &&
                self.$lodash().includes(child.school.name.toLowerCase(), query)
            )
          )
        })
      }

      return partialChildren
    },
    getChildIsVisibleById (id) {
      var children = this.getChildren()
      for (var i = 0; i < children.length; i++) {
        if (children[i].id === id) {
          return true
        }
      }
      return false
    },
    // Fix for Freshdesk ticket #47088
    // Use this method instead of getChildIsVisibleById if you want to check
    // if a child is visible OR should be visible (as it might not be in local storage)
    getChildShouldBeVisibleById (id) {
      if (this.getChildIsVisibleById(id) === true) {
        return true
      }
      var allChildren = this.getChildren(true)
      var idIsInAllChildren = false
      for (var i = 0; i < allChildren.length; i++) {
        if (allChildren[i].id === id) {
          idIsInAllChildren = true
        }
      }
      if (idIsInAllChildren === false) {
        return true
      } else {
        return false
      }
    },
    getAge (dateOfBirth) {
      if (dateOfBirth === null) {
        return ''
      }
      var years = this.$moment().diff(this.$moment(dateOfBirth), 'years')
      var months = this.$moment().diff(this.$moment(dateOfBirth), 'months')
      return years + ' jaar (' + months + 'm)'
    },
    getAgeInYears (dateOfBirth) {
      if (dateOfBirth === null) {
        return null
      }
      return this.$moment().diff(this.$moment(dateOfBirth), 'years');
    },
    getOrderChildrenBy () {
      let orderBy = this.$store.getters.orderChildrenBy
      if (orderBy === null) {
        orderBy = this.getApplicationSetting('ipad_sort_children_by')
        if (
            orderBy !== 'first_name'
            &&
            orderBy !== 'last_name'
            &&
            orderBy !== 'date_of_birth'
        ) {
          orderBy = 'first_name'
        }
      }
      return orderBy
    },
    getOrderChildrenSort () {
      var sort = this.$store.getters.orderChildrenSort
      if (sort === null) {
        sort = 'asc'
      }
      return sort
    },
    sortChildren (children, oneTimeOrderBy, oneTimeSort) {
      children = children || []
      oneTimeOrderBy = oneTimeOrderBy || false
      oneTimeSort = oneTimeSort || false

      let globalOrderChildrenBy = this.getOrderChildrenBy()
      let globalOrderChildrenSort = this.getOrderChildrenSort()

      var orderBy = oneTimeOrderBy || globalOrderChildrenBy
      var sort = oneTimeSort || globalOrderChildrenSort

      // Tijdelijk op deze manier.
      // Sorteren met date object erg traag
      if (orderBy === 'date_of_birth') {
        if (sort === 'desc') {
          return this.$lodash().sortBy(children, [child => child.date_of_birth], 'asc')
        } else {
          return this.$lodash().sortBy(children, [child => child.date_of_birth], 'asc').reverse()
        }
      }
      if (orderBy === 'date') {
        if (sort === 'desc') {
          return this.$lodash().sortBy(children, [child => child.date], 'asc').reverse()
        } else {
          return this.$lodash().sortBy(children, [child => child.date], 'asc')
        }
      }
      if (sort === 'desc') {
        return this.$lodash().sortBy(children, [child => child[orderBy].toLowerCase()], 'asc').reverse()
      } else {
        return this.$lodash().sortBy(children, [child => child[orderBy].toLowerCase()], 'asc')
      }
    },
    getChildIdsInOrder () {
      var children = this.getChildren()
      var ids = []
      for (var i = 0; i < children.length; i++) {
        if (children[i].id) {
          ids.push(children[i].id)
        }
      }
      return ids
    },
    sortArrayByChildOrder (data, dataKey) {
      var childIdsInOrder = this.getChildIdsInOrder()
      var result = []

      childIdsInOrder.forEach(function(key) {
        var found = false
        data = data.filter(function(item) {
          if(!found && item[dataKey] === key) {
            result.push(item)
            found = true
            return false
          } else
            return true
        })
      })

      return result
    },
    getPresentChildIds () {
      let presence = JSON.parse(JSON.stringify(this.$store.getters.childrenPresence))
      let children = []
      if (presence.length > 0) {
        for (let i = 0; i < presence.length; i++) {
          if (this.getChildPresence({id: presence[i].child_id})) {
            children.push(presence[i].child_id)
          }
        }
      }
      return children
    },
    async getBkr (date) {
      let children = this.getPresentChildIds()
      let agesInYears = []
      let ignoreFilter = false
      if (this.getApplicationSetting('ipad_real_time_bkr_ignore_child_filter') === '1') {
        ignoreFilter = true
      }
      for (let i = 0; i < children.length; i++) {
        let child = this.getChild(children[i], ignoreFilter)
        let ageInYears = this.getAgeInYears(child.date_of_birth)
        if (ageInYears !== null) {
          agesInYears.push(ageInYears)
        }
      }
      return this.$request.get('/bkr?date=' + this.$moment(date).format('YYYY-MM-DD')  + '&ages_in_years=' + agesInYears.join(','))
    }
  }
}
